<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('users')">Użytkownicy</inertia-link>
      <span class="text-shtax-400 font-medium">/</span> Nowy użytkownik
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden md:overflow-visible max-w-3xl">
      <form @submit.prevent="store" class="z-0">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pr-6 pb-8 w-full lg:w-1/2" label="Imię" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pr-6 pb-8 w-full lg:w-1/2" label="Nazwisko" />
          <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-1/2" label="Adres e-mail" />
          <text-input v-model="form.password" :error="form.errors.password" class="pr-6 pb-8 w-full lg:w-1/2" type="password" autocomplete="new-password" label="Hasło" />
          <multiselect-input v-model="form.role" :error="form.errors.role" class="pr-6 pb-8 w-full lg:w-full" label="Rola" :options="options" />

        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center rounded-b-md">
          <loading-button :loading="form.processing" class="btn-shtax" type="submit">Stwórz użytkownika</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'

export default {
  metaInfo: { title: 'Nowy użytkownik' },
  components: {
    LoadingButton,
    TextInput,
    MultiselectInput
  },
  layout: Layout,
  props: {
    roles: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        first_name: null,
        last_name: null,
        email: null,
        password: null,
        // owner: false,
        role: null,
        // photo: null,
      }),
      options: this.roles
    }
  },
  methods: {
    store() {
      this.form.post(this.route('users.store'))
    },
  }
}
</script>
